// src/composables/useValidation.js
import { ref } from 'vue';

export function useValidation() {
  const errors = ref({});

  const validateField = (fieldName, value, rules) => {
    if (!rules || !rules.length) return true;

    for (const rule of rules) {
      const result = rule(value);
      if (result !== true) {
        // Encontramos un error. Actualizamos el objeto completo
        // para que Vue 2.7 detecte el cambio reactivamente.
        errors.value = { ...errors.value, [fieldName]: result };
        return false;
      }
    }

    // Si no hay error, limpiamos el campo específico
    errors.value = { ...errors.value, [fieldName]: null };
    return true;
  };

  const validateForm = (formData, validationRules) => {
    let isValid = true;
    Object.keys(validationRules).forEach(field => {
      const isFieldValid = validateField(field, formData[field], validationRules[field]);
      if (!isFieldValid) isValid = false;
    });
    return isValid;
  };

  const clearErrors = () => {
    errors.value = {};
  };

  return {
    errors,
    validateField,
    validateForm,
    clearErrors
  };
}